<div id="shadow-wrapper" class="wrapper-shadow" (scroll)="showBoxShadow()">
    <div class="shadow shadow--bottom"></div>
    <div appFavIcon class="container">
        <header role="header">
            <mat-toolbar id="banner" role="banner" color="primary">
                @if ( (brandingService.brandingSubject | async)?.logoUrl; as
                logo ) {
                <img
                    alt="{{ clientName$ | async }}"
                    aria-label="Company logo"
                    src="{{ logo }}"
                    (error)="errorHandler($event)"
                />
                } @else {
                <img
                    class="w-60"
                    aria-label="Code Technology logo"
                    alt="Code Technology logo"
                    src="assets/img/code_logo.svg"
                />
                }
            </mat-toolbar>
        </header>
        <main role="main">
            @switch (currentStatusType) { @case (statusType.InProgress) {
            <router-outlet></router-outlet>
            } @case (statusType.Pending) {
            <router-outlet></router-outlet>
            } @default {
            <app-progress-bar [status]="status$ | async"></app-progress-bar>
            @if ( (questionnaireService.questionnaireSubject | async)
            ?.statusMessage; as statusMessage ) {
            <div>
                <app-status-page [statusText]="statusMessage"></app-status-page>
            </div>
            } } }
        </main>

        <footer role="contentinfo">
            <section
                role="region"
                [innerHtml]="
                    $safeNavigationMigration(
                        (metaDataService.metaData$ | async)?.copyright
                    )
                "
                aria-label="Copyright CODE Technology"
            ></section>

            <a
                href="https://www.w3.org/WAI/WCAG2AA-Conformance"
                title="Explanation of WCAG 2 Level AA conformance"
                target="_blank"
            >
                <img
                    aria-label="Level AA conformance, W3C WAI Web Content Accessibility Guidelines 2.1"
                    src="https://www.w3.org/WAI/WCAG21/wcag2.1AA-blue-v"
                    alt="Level AA conformance, W3C WAI Web Content Accessibility Guidelines 2.1"
                />
            </a>
        </footer>
    </div>
</div>
